export var DEFAULT_PAGE_NO=0;
export var DEFAULT_PAGE_SIZE_10=10;
export var DEFAULT_PAGE_SIZE_5=5;